<template>
    <div>
        <view-item v-if="!!item" :item="item" @success="alertSuccess" @delete-item="deleteType" @cancel="item = false"
            @error="showError"></view-item>

        <list-items v-else title="Customer Segments" :items="customerSegments" @show-item="showItem" ref="table">
            <b-button block variant="primary" v-if="hasPermissionCreate" @click="item = {}"><img v-b-tooltip.hover
                    :title="$addLabel()" src="@/assets/images/icon/blue-add.svg" /></b-button>
        </list-items>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import errorHandlingMixins from '@/mixins/errorHandlingMixins'

import ListItems from './ListItems'
import ViewItem from './ViewItem'

export default {
    name: 'CustomerSegments',
    components: {
        ListItems,
        ViewItem,
    },
    mixins: [
        popupMixins,
        utilityMixins,
        permissionsMixins,
        errorHandlingMixins,
    ],
    data: () => {
        return {
            item: null,
        }
    },
    mounted() {
        this.doSearch()
    },
    computed: {
        componentName() { return this.$translate('customer_segment') },
        customerSegments() {
            const customerSegments =
                this.$store.state.customerSegments.customer_segments
                || []
            return customerSegments
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },

    methods: {
        doSearch() {
            this.$store.dispatch('customerSegments/fetchAll')
        },

        showItem(id) {
            const item = this.customerSegments.find(x => x.id === id)
            this.item = { ...item }
        },

        alertSuccess(action, message) {
            console.log(this.item)
            this.genericToast(
                this.componentName,
                this.$translate(`${action}d`),
                'success',
                `${this.componentName
                } ${message}`
            )
            this.item = null
            this.doSearch()
        },

        showError(error) {
            this.genericToast(
                this.componentName,
                this.$translate('error'),
                'danger',
                `${error.message}`
            )
        },
    },
}
</script>
<style></style>
